import InsureScreen from './InsureScreen';

export default InsureScreen;
